import { useEffect, useState } from "react";
import { IDineInHistoryPage } from "../models/IDineIn";
import { dineInErrorCode, dineInErrorDescription, getDineInHistory } from "../services/dineInService";
import HistoryBillItem, { formatDateTime } from "./HistoryBillItem";

interface Props {
  tableId: string;
  tableNumber: number;
  tableLabel?: string;
  onClose: () => void;
}

export default function TableHistoryModal({ tableId, tableNumber, tableLabel, onClose }: Props) {
  const [data, setData] = useState<IDineInHistoryPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [expanded, setExpanded] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError("");
    getDineInHistory({ tableId, page, pageSize: 10 })
      .then((res) => setData(res.data))
      .catch((err) => {
        const code = dineInErrorCode(err);
        setError(code === "InvalidHistoryRange"
          ? (dineInErrorDescription(err) ?? "Tarih aralığı geçersiz.")
          : (dineInErrorDescription(err) ?? "Geçmiş yüklenemedi."));
      })
      .finally(() => setLoading(false));
  }, [tableId, page]);

  return (
    <div className="dinein-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="dinein-modal dinein-modal--wide">
        <div className="dinein-modal__head">
          <div>
            <div className="dinein-modal__title"><i className="bi bi-clock-history me-2"></i>Masa Geçmişi</div>
            <div className="dinein-modal__sub">
              Masa {tableNumber}{tableLabel ? ` — ${tableLabel}` : ""}
              {data && <> · {formatDateTime(data.fromUtc)} – {formatDateTime(data.toUtc)}</>}
            </div>
          </div>
          <button className="dinein-icon-btn" onClick={onClose}><i className="bi bi-x-lg"></i></button>
        </div>

        <div className="dinein-modal__body">
          {loading ? (
            <div className="dinein-center dinein-center--tall"><span className="spinner-border" /></div>
          ) : error ? (
            <div className="dinein-alert dinein-alert--error"><i className="bi bi-exclamation-circle-fill"></i><span>{error}</span></div>
          ) : !data || data.items.length === 0 ? (
            <div className="dinein-center dinein-center--tall">
              <i className="bi bi-inbox"></i>
              <div>Bu dönemde kayıt yok.</div>
            </div>
          ) : (
            <>
              <div className="dinein-history-list">
                {data.items.map((item) => (
                  <HistoryBillItem
                    key={item.session.orderCode}
                    item={item}
                    expanded={expanded === item.session.orderCode}
                    onToggle={() => setExpanded(expanded === item.session.orderCode ? null : item.session.orderCode)}
                  />
                ))}
              </div>

              {data.totalPages > 1 && (
                <div className="dinein-pagination">
                  <button className="dinein-btn dinein-btn--ghost" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <span>{data.page} / {data.totalPages} · {data.totalCount} oturum</span>
                  <button className="dinein-btn dinein-btn--ghost" disabled={page >= data.totalPages} onClick={() => setPage((p) => p + 1)}>
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
